class HotCollection extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.swiperContainer = this.querySelector('.swiper');
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        if (this.swiperContainer) {
            const scrollbar = this.querySelector('.swiper-scrollbar');
            this.swiper = new Swiper(this.swiperContainer, {
                slidesPerView: 4,
                spaceBetween: 40,
                scrollbar: {
                    el: scrollbar,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.8,
                        spaceBetween: 15
                    },
                    768: {
                        slidesPerView: 2.8,
                        spaceBetween: 30
                    },
                    1000: {
                        slidesPerView: 4,
                        spaceBetween: 40
                    }
                }
            });
        }
    }
}

customElements.define('hot-collection', HotCollection);
